// Code generated by @hex-insights/frontend-generator; DO NOT EDIT.

export const permissions = {
	User: {
		Create: { Admin: "User.Create.Admin", Basic: "User.Create.Basic" },
		View: { Admin: "User.View.Admin", Basic: "User.View.Basic" },
		Update: { Admin: "User.Update.Admin", Basic: "User.Update.Basic" },
		Delete: { Admin: "User.Delete.Admin", Basic: "User.Delete.Basic" },
	},
	Permission: {
		Create: { Admin: "Permission.Create.Admin", Basic: "Permission.Create.Basic" },
		View: { Admin: "Permission.View.Admin", Basic: "Permission.View.Basic" },
		Update: { Admin: "Permission.Update.Admin", Basic: "Permission.Update.Basic" },
		Delete: { Admin: "Permission.Delete.Admin", Basic: "Permission.Delete.Basic" },
	},
	PermissionGroup: {
		Create: { Admin: "PermissionGroup.Create.Admin", Basic: "PermissionGroup.Create.Basic" },
		View: { Admin: "PermissionGroup.View.Admin", Basic: "PermissionGroup.View.Basic" },
		Update: { Admin: "PermissionGroup.Update.Admin", Basic: "PermissionGroup.Update.Basic" },
		Delete: { Admin: "PermissionGroup.Delete.Admin", Basic: "PermissionGroup.Delete.Basic" },
	},
	LoginRecord: {
		Create: { Admin: "LoginRecord.Create.Admin", Basic: "LoginRecord.Create.Basic" },
		View: { Admin: "LoginRecord.View.Admin", Basic: "LoginRecord.View.Basic" },
		Update: { Admin: "LoginRecord.Update.Admin", Basic: "LoginRecord.Update.Basic" },
		Delete: { Admin: "LoginRecord.Delete.Admin", Basic: "LoginRecord.Delete.Basic" },
	},
	MFAFactor: {
		Create: { Admin: "MFAFactor.Create.Admin", Basic: "MFAFactor.Create.Basic" },
		View: { Admin: "MFAFactor.View.Admin", Basic: "MFAFactor.View.Basic" },
		Update: { Admin: "MFAFactor.Update.Admin", Basic: "MFAFactor.Update.Basic" },
		Delete: { Admin: "MFAFactor.Delete.Admin", Basic: "MFAFactor.Delete.Basic" },
	},
	MFAInvalidOTPAttempt: {
		Create: { Admin: "MFAInvalidOTPAttempt.Create.Admin", Basic: "MFAInvalidOTPAttempt.Create.Basic" },
		View: { Admin: "MFAInvalidOTPAttempt.View.Admin", Basic: "MFAInvalidOTPAttempt.View.Basic" },
		Update: { Admin: "MFAInvalidOTPAttempt.Update.Admin", Basic: "MFAInvalidOTPAttempt.Update.Basic" },
		Delete: { Admin: "MFAInvalidOTPAttempt.Delete.Admin", Basic: "MFAInvalidOTPAttempt.Delete.Basic" },
	},
	Session: {
		Create: { Admin: "Session.Create.Admin", Basic: "Session.Create.Basic" },
		View: { Admin: "Session.View.Admin", Basic: "Session.View.Basic" },
		Update: { Admin: "Session.Update.Admin", Basic: "Session.Update.Basic" },
		Delete: { Admin: "Session.Delete.Admin", Basic: "Session.Delete.Basic" },
	},
	TrustedDevice: {
		Create: { Admin: "TrustedDevice.Create.Admin", Basic: "TrustedDevice.Create.Basic" },
		View: { Admin: "TrustedDevice.View.Admin", Basic: "TrustedDevice.View.Basic" },
		Update: { Admin: "TrustedDevice.Update.Admin", Basic: "TrustedDevice.Update.Basic" },
		Delete: { Admin: "TrustedDevice.Delete.Admin", Basic: "TrustedDevice.Delete.Basic" },
	},
	Announcement: {
		Create: { Admin: "Announcement.Create.Admin", Basic: "Announcement.Create.Basic" },
		View: { Admin: "Announcement.View.Admin", Basic: "Announcement.View.Basic" },
		Update: { Admin: "Announcement.Update.Admin", Basic: "Announcement.Update.Basic" },
		Delete: { Admin: "Announcement.Delete.Admin", Basic: "Announcement.Delete.Basic" },
	},
	CalendarEvent: {
		Create: { Admin: "CalendarEvent.Create.Admin", Basic: "CalendarEvent.Create.Basic" },
		View: { Admin: "CalendarEvent.View.Admin", Basic: "CalendarEvent.View.Basic" },
		Update: { Admin: "CalendarEvent.Update.Admin", Basic: "CalendarEvent.Update.Basic" },
		Delete: { Admin: "CalendarEvent.Delete.Admin", Basic: "CalendarEvent.Delete.Basic" },
	},
	CalendarEventResponse: {
		Create: { Admin: "CalendarEventResponse.Create.Admin", Basic: "CalendarEventResponse.Create.Basic" },
		View: { Admin: "CalendarEventResponse.View.Admin", Basic: "CalendarEventResponse.View.Basic" },
		Update: { Admin: "CalendarEventResponse.Update.Admin", Basic: "CalendarEventResponse.Update.Basic" },
		Delete: { Admin: "CalendarEventResponse.Delete.Admin", Basic: "CalendarEventResponse.Delete.Basic" },
	},
	MediaAttachment: {
		Create: { Admin: "MediaAttachment.Create.Admin", Basic: "MediaAttachment.Create.Basic" },
		View: { Admin: "MediaAttachment.View.Admin", Basic: "MediaAttachment.View.Basic" },
		Update: { Admin: "MediaAttachment.Update.Admin", Basic: "MediaAttachment.Update.Basic" },
		Delete: { Admin: "MediaAttachment.Delete.Admin", Basic: "MediaAttachment.Delete.Basic" },
	},
	Message: {
		Create: { Admin: "Message.Create.Admin", Basic: "Message.Create.Basic" },
		View: { Admin: "Message.View.Admin", Basic: "Message.View.Basic" },
		Update: { Admin: "Message.Update.Admin", Basic: "Message.Update.Basic" },
		Delete: { Admin: "Message.Delete.Admin", Basic: "Message.Delete.Basic" },
	},
	MessageGroup: {
		Create: { Admin: "MessageGroup.Create.Admin", Basic: "MessageGroup.Create.Basic" },
		View: { Admin: "MessageGroup.View.Admin", Basic: "MessageGroup.View.Basic" },
		Update: { Admin: "MessageGroup.Update.Admin", Basic: "MessageGroup.Update.Basic" },
		Delete: { Admin: "MessageGroup.Delete.Admin", Basic: "MessageGroup.Delete.Basic" },
	},
	MessageGroupArchivePoint: {
		Create: { Admin: "MessageGroupArchivePoint.Create.Admin", Basic: "MessageGroupArchivePoint.Create.Basic" },
		View: { Admin: "MessageGroupArchivePoint.View.Admin", Basic: "MessageGroupArchivePoint.View.Basic" },
		Update: { Admin: "MessageGroupArchivePoint.Update.Admin", Basic: "MessageGroupArchivePoint.Update.Basic" },
		Delete: { Admin: "MessageGroupArchivePoint.Delete.Admin", Basic: "MessageGroupArchivePoint.Delete.Basic" },
	},
	MessageTopic: {
		Create: { Admin: "MessageTopic.Create.Admin", Basic: "MessageTopic.Create.Basic" },
		View: { Admin: "MessageTopic.View.Admin", Basic: "MessageTopic.View.Basic" },
		Update: { Admin: "MessageTopic.Update.Admin", Basic: "MessageTopic.Update.Basic" },
		Delete: { Admin: "MessageTopic.Delete.Admin", Basic: "MessageTopic.Delete.Basic" },
	},
	Newsletter: {
		Create: { Admin: "Newsletter.Create.Admin", Basic: "Newsletter.Create.Basic" },
		View: { Admin: "Newsletter.View.Admin", Basic: "Newsletter.View.Basic" },
		Update: { Admin: "Newsletter.Update.Admin", Basic: "Newsletter.Update.Basic" },
		Delete: { Admin: "Newsletter.Delete.Admin", Basic: "Newsletter.Delete.Basic" },
	},
	Post: {
		Create: { Admin: "Post.Create.Admin", Basic: "Post.Create.Basic" },
		View: { Admin: "Post.View.Admin", Basic: "Post.View.Basic" },
		Update: { Admin: "Post.Update.Admin", Basic: "Post.Update.Basic" },
		Delete: { Admin: "Post.Delete.Admin", Basic: "Post.Delete.Basic" },
	},
	SharingPolicy: {
		Create: { Admin: "SharingPolicy.Create.Admin", Basic: "SharingPolicy.Create.Basic" },
		View: { Admin: "SharingPolicy.View.Admin", Basic: "SharingPolicy.View.Basic" },
		Update: { Admin: "SharingPolicy.Update.Admin", Basic: "SharingPolicy.Update.Basic" },
		Delete: { Admin: "SharingPolicy.Delete.Admin", Basic: "SharingPolicy.Delete.Basic" },
	},
	SocialComment: {
		Create: { Admin: "SocialComment.Create.Admin", Basic: "SocialComment.Create.Basic" },
		View: { Admin: "SocialComment.View.Admin", Basic: "SocialComment.View.Basic" },
		Update: { Admin: "SocialComment.Update.Admin", Basic: "SocialComment.Update.Basic" },
		Delete: { Admin: "SocialComment.Delete.Admin", Basic: "SocialComment.Delete.Basic" },
	},
	SocialReaction: {
		Create: { Admin: "SocialReaction.Create.Admin", Basic: "SocialReaction.Create.Basic" },
		View: { Admin: "SocialReaction.View.Admin", Basic: "SocialReaction.View.Basic" },
		Update: { Admin: "SocialReaction.Update.Admin", Basic: "SocialReaction.Update.Basic" },
		Delete: { Admin: "SocialReaction.Delete.Admin", Basic: "SocialReaction.Delete.Basic" },
	},
	UserExternalNotificationMarker: {
		Create: {
			Admin: "UserExternalNotificationMarker.Create.Admin",
			Basic: "UserExternalNotificationMarker.Create.Basic",
		},
		View: { Admin: "UserExternalNotificationMarker.View.Admin", Basic: "UserExternalNotificationMarker.View.Basic" },
		Update: {
			Admin: "UserExternalNotificationMarker.Update.Admin",
			Basic: "UserExternalNotificationMarker.Update.Basic",
		},
		Delete: {
			Admin: "UserExternalNotificationMarker.Delete.Admin",
			Basic: "UserExternalNotificationMarker.Delete.Basic",
		},
	},
	UserGroup: {
		Create: { Admin: "UserGroup.Create.Admin", Basic: "UserGroup.Create.Basic" },
		View: { Admin: "UserGroup.View.Admin", Basic: "UserGroup.View.Basic" },
		Update: { Admin: "UserGroup.Update.Admin", Basic: "UserGroup.Update.Basic" },
		Delete: { Admin: "UserGroup.Delete.Admin", Basic: "UserGroup.Delete.Basic" },
	},
	UserViewRecord: {
		Create: { Admin: "UserViewRecord.Create.Admin", Basic: "UserViewRecord.Create.Basic" },
		View: { Admin: "UserViewRecord.View.Admin", Basic: "UserViewRecord.View.Basic" },
		Update: { Admin: "UserViewRecord.Update.Admin", Basic: "UserViewRecord.Update.Basic" },
		Delete: { Admin: "UserViewRecord.Delete.Admin", Basic: "UserViewRecord.Delete.Basic" },
	},
};
